import React from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from "primereact/column";
import Grid from '@material-ui/core/Grid';
import Paper from "@material-ui/core/Paper";
import TitlePage from "../../app/Title/TitlePage/TitlePageView";
import LinearProgress from "@material-ui/core/LinearProgress";
import {
    numberWithCommaDataTableTemplate,
    rateDataTableTemplate,
    rateMultipliedByOneHundredDataTableTemplate
} from "../../utils/formatters/Numbers";
import TabViewPresval from "../../components/tabView";
import {getIconFromMenu} from "../../utils/icon/IconProcessor";


const Ventanilla = ({
                        bestOrders,
                        lenderOrders,
                        lenderOrderActionTemplate,
                        borrowerOrderActionTemplate,
                        borrowerOrders,
                        loans,
                        tabValue,
                        handleChangeTabIndex,
                        handleSelectBestOrder,
                        headerBestOrders,
                        headerLoans,
                        isLoading,
                        ...props
                    }) => {
    return (

        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <TitlePage title="Ventanilla" menuIcon={getIconFromMenu("Ventanilla ")}/>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            scrollable={true}
                            scrollHeight="90px"
                            headerColumnGroup={props.headerGroupBestOrders}
                            value={bestOrders}
                            selectionMode="single"
                            onSelectionChange={handleSelectBestOrder}
                            selection={props.selectedBestOrder}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column field="emisora" header="Instrumento" style={{width: '30%'}}/>
                            <Column field="cantidadPtm" header="Cantidad PTM" body={numberWithCommaDataTableTemplate}/>
                            <Column field="plazoPtm" header="Plazo" body={numberWithCommaDataTableTemplate}/>
                            <Column field="tasaPtm" header="Tasa" body={rateDataTableTemplate}/>
                            <Column field="sobreTasaPtm" header="Sobretasa" body={rateDataTableTemplate}/>
                            <Column field="cantidadPtt" header="Cantidad PTT" body={numberWithCommaDataTableTemplate}/>
                            <Column field="plazoPtt" header="Plazo" body={numberWithCommaDataTableTemplate}/>
                            <Column field="tasaPtt" header="Tasa" body={rateDataTableTemplate}/>
                            <Column field="sobreTasaPtt" header="Sobretasa" body={rateDataTableTemplate}/>
                        </DataTable>
                    </Grid>
                    <Grid item xs={12}>
                        <TabViewPresval modelOptions={props.items}
                                        activeIndex={props.tabIndex}
                                        onSelect={props.changeTab}/>

                    </Grid>
                    <Grid item xs={12}>
                        {
                            props.tabIndex === 0 &&
                            <DataTable
                                responsive={true}
                                value={lenderOrders}
                                resizableColumns={true}
                                columnResizeMode={"fit"}>
                                <Column
                                    field="folio"
                                    header="Folio"
                                    style={{textAlign: 'left'}}
                                    sortable={true}/>
                                <Column
                                    field="cantidad"
                                    header="Títulos"
                                    body={numberWithCommaDataTableTemplate}
                                    style={{textAlign: 'right'}}
                                    sortable={true}/>
                                <Column
                                    field="plazo"
                                    header="Plazo"
                                    body={numberWithCommaDataTableTemplate}
                                    style={{textAlign: 'right'}}
                                    sortable={true}/>
                                <Column
                                    field="tasa"
                                    header="Tasa"
                                    body={rateDataTableTemplate}
                                    style={{textAlign: 'right'}}
                                    sortable={true}/>
                                <Column
                                    field="sobreTasa"
                                    header="Sobretasa"
                                    body={rateDataTableTemplate}
                                    style={{textAlign: 'right'}}
                                    sortable={true}/>
                                <Column
                                    field="banFecValor"
                                    header="FV"
                                    style={{textAlign: 'right'}}
                                    sortable={true}/>
                                <Column
                                    field="banOTC"
                                    header="OTC"
                                    style={{textAlign: 'right'}}
                                    sortable={true}
                                />
                                <Column
                                    header="Acción"
                                    body={lenderOrderActionTemplate}
                                    style={{textAlign: 'center'}}/>
                            </DataTable>
                        }
                        {
                            props.tabIndex === 1 &&
                            <DataTable
                                responsive={true}
                                value={borrowerOrders}
                                resizableColumns={true}
                                columnResizeMode={"fit"}>
                                <Column field="folio" header="Folio" style={{textAlign: 'left'}} sortable={true}/>
                                <Column field="cantidad" header="Títulos"
                                        style={{textAlign: 'right'}}
                                        body={numberWithCommaDataTableTemplate} sortable={true}/>
                                <Column field="plazo" header="Plazo"
                                        style={{textAlign: 'right'}}
                                        body={numberWithCommaDataTableTemplate} sortable={true}/>
                                <Column field="tasa" header="Tasa"
                                        style={{textAlign: 'right'}}
                                        body={rateDataTableTemplate} sortable={true}/>
                                <Column field="sobreTasa" header="Sobretasa"
                                        style={{textAlign: 'right'}}
                                        body={rateDataTableTemplate} sortable={true}/>
                                <Column field="fechaValor" header="FV"
                                        style={{textAlign: 'right'}} sortable={true}/>
                                <Column field="otc" header="OTC"
                                        style={{textAlign: 'right'}} sortable={true}/>
                                <Column header="Acción"
                                        body={borrowerOrderActionTemplate}
                                        style={{textAlign: 'center'}}/>
                            </DataTable>
                        }
                        {
                            props.tabIndex === 2 &&
                            <DataTable
                                header={props.headerTrades}
                                responsive={true}
                                value={loans}
                                resizableColumns={true}
                                columnResizeMode={"fit"}>
                                <Column field="folio" header="Folio"
                                        style={{textAlign: 'left'}} sortable={true}/>
                                <Column field="status" header="Estatus"
                                        style={{textAlign: 'left'}} sortable={true}/>
                                <Column field="cantidad" header="Títulos"
                                        style={{textAlign: 'right'}}
                                        body={numberWithCommaDataTableTemplate} sortable={true}/>
                                <Column field="plazo" header="Plazo"
                                        style={{textAlign: 'right'}}
                                        body={numberWithCommaDataTableTemplate} sortable={true}/>
                                <Column field="sobreTasa" header="Sobretasa"
                                        style={{textAlign: 'right'}}
                                        body={rateMultipliedByOneHundredDataTableTemplate} sortable={true}/>
                                <Column field="hora" header="Hora"
                                        style={{textAlign: 'right'}} sortable={true}/>
                            </DataTable>
                        }
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};
export default Ventanilla;
